import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import {Factory as FilterFactory} from './components/desktop/filter/factory';
import {Factory as PlayersListFactory} from './components/desktop/players-list/factory';
import Dashboard from './components/desktop/dashboard';

class UsedPlayersList extends Component {
    render() {
        const {sportConfig} = this.props;

        const Filter = FilterFactory.getComponent(sportConfig);
        const PlayersList = PlayersListFactory.getComponent(sportConfig);

        return (
            <div className="tab-content players-content show">
                <Dashboard />
                <Filter sport={sportConfig.getSport()} />
                <PlayersList />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const UsedPlayersListComponent = connect(mapStatesToProps)(UsedPlayersList);

export {UsedPlayersListComponent};
